import * as Endpoints from '../Entities/EndPoints'
import Axios from '../Axios'

const API = Axios.getInstance
const API_FORMDATA = Axios.getInstanceForFormData

export const getRiskDetails = (pageNumber, pageSize, type, stage, loginId) => {
    const params = { pageNumber, pageSize, type, stage, loginId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_RISKS, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}
export const getRiskHistory = (riskId, orgId) => {
    const params = { riskId, orgId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_RISK_HISTORY, { params }, { headers: { 'Content-Type': 'application/json' } })
        .then((response) => response)
}
export const getRiskPeriodicity = (riskId, loginId, orgId) => {
    const params = { riskId, loginId, orgId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_RISK_PERIODICITY, { params })
        .then((response) => response)
}
export const getRiskDetailsCounts = (pageNumber, pageSize, type, stage, loginId) => {
    const params = { pageNumber, pageSize, type, stage, loginId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_RISKS, { params, headers: { 'Content-Type': 'application/json' } })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getRiskViewHistory = (pageNumber, pageSize, loginId) => {
    const params = { pageNumber, pageSize, loginId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.RISK_HISTORY, { params, headers: { 'Content-Type': 'application/json' } })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getRiskDispute = (pageNumber, pageSize, loginId) => {
    const params = { pageNumber, pageSize, loginId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.RISK_DISPUTE, { params, headers: { 'Content-Type': 'application/json' } })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getRidkDetailsById = (riskId, loginId) => {
    const params = { riskId, loginId }

    return API(Endpoints.API_ENDPOINT)
        .get(Endpoints.GET_RISK_BY_ID, { params }, { headers: { 'Content-Type': 'application/json' } })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createRisk = (loginId, data) => {
    const params = { loginId }

    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_RISK, data, { params })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createMitigationPlan = (data) => {
    return API_FORMDATA(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_MITIGATION_PLAN, data)
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const createRiskAnalysis = (data) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.CREATE_RISK_ANALYZE, data, { headers: { 'Content-Type': 'application/json' } })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getNonCompliance = (orgId, userId) => {
    const data = { orgId, userId }

    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.GET_NON_COMPLIANCE, data, { headers: { 'Content-Type': 'application/json' } })
        .then((response) => response)
        .catch((err) => ({ err }))
}

export const getRiskSearchHistory = (loginId, filter) => {
    return API(Endpoints.API_ENDPOINT)
        .post(Endpoints.GET_RISK_SEARCH_HISTORY, filter, {
            params: { loginId },
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )
        .then((response) => response)
        .catch((err) => ({ err }))
}
